export default "__VITE_ASSET__D9MXi5en__"